var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticStyle:{"padding":"10px 20px 0"}},[_c('el-button',{directives:[{name:"print",rawName:"v-print",value:(_vm.option),expression:"option"}],attrs:{"type":"success","plain":""}},[_vm._v("打印")])],1),_c('div',{attrs:{"id":"printbox"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }